import CheckboxSelect from './checkbox-select';

export default CheckboxSelect;